{
  "meta": {
    "home": {
      "title": "BYHOURS: Book in more than 4,000 hotels by the hour",
      "description": "Book hotel rooms by the hour at your favorite hotel and decide your check-in time. Choose from more than 4,000 3, 4 and 5 star hotels and book in more than 25 countries. Access all hotel services with free cancellation. Book now with BYHOURS, leader in Microstays.",
      "keywords": "Hotels by the hour, hotel by the hour, hotel hours, byhours, byhours.com, rooms by the hour, hotels by the hour in Barcelona, hotels by the hour in Madrid, hotels by the hour in Seville, hotels by the hour in Valencia, hotels by the hour in Bilbao, micro-stay, microstay, by hours, microstays, hotel hours, hotel by hours, day hotel, hotel for couples, couples hotel, budget hotel, hotel for work, airport hotel, day rooms, dayuse, daybreak, hotel by the hour for work, hotel by the hour near airport, hotel to rest airport, airport hotel, hotel by the hour airport, transit hotel, hotel near train station, day room, rooms during the day, byhours"
    },
    "search": {
      "title": "Hotels by the hour in {city_name}",
      "description": "The best hotels in {city_name} available by the hour in 3, 6 and 24 hour packages. For day and night use with access to all hotel facilities. Free cancellation and flexible check-in.",
      "keywords": "byhours, hotels by the hour in {city_name}, buyhours, hotel hours in {city_name}, book by the hour in {city_name}, hotels {city_name}, microstays {city_name}, rooms by the hour {city_name}, hotel booking by the hour {city_name}, day hotel {city_name}, {city_name}, byhours {city_name}, day room in {city_name}, room for a few hours during the day in {city_name}, microstays in {city_name}"
    },
    "detail": {
      "title": "{hotel_name} {city_name} for 3, 6 or 24 hours",
      "description": "Enjoy a few hours of relaxation at {hotel_name} in {city_name} and pay only for the time you need. Choose the check-in time that suits you best and enjoy all facilities such as the spa, pool or restaurant. {hotel_description}",
      "keywords": "byhours {hotel_name}, by hours {hotel_name}, buyhours {hotel_name}, {hotel_name}, hotel hours {hotel_name}, hotel by the hour {hotel_name}, hotels by the hour {city_name}, book by the hour in {hotel_name}, hotels {city_name}, microstays {hotel_name}, rooms by the hour {hotel_name}, hotel booking by the hour {city_name}, day hotel {hotel_name}, book rooms by the hour {hotel_name}"
    },
    "landing": {
      "title": "Hotels by the hour in {city_name}",
      "description": "The best hotels in {city_name} available by the hour in 3, 6 and 24 hour packages. For day and night use with access to all hotel facilities. Free cancellation and flexible check-in.",
      "keywords": "byhours, hotels by the hour in {city_name}, buyhours, hotel hours in {city_name}, book by the hour in {city_name}, hotels {city_name}, microstays {city_name}, rooms by the hour {city_name}, hotel booking by the hour {city_name}, day hotel {city_name}, {city_name}, byhours {city_name}, day room in {city_name}, room for a few hours during the day in {city_name}, microstays in {city_name}"
    },
    "como-funciona": {
      "title": "How to book hotels by the hour: step by step",
      "description": "Discover how in just 4 simple steps you can enjoy 3, 6 or 24 hours of hotel in more than 600 destinations.",
      "keywords": "questions, steps, how to book, byhours, hotels by the hour"
    },
    "byhours-destinations": {
      "title": "Book in more than 600 destinations",
      "description": "Book hotel rooms by the hour at your favorite hotel and decide your check-in time. Choose from more than 4,000 3, 4 and 5 star hotels and book in more than 600 destinations. Access all hotel services with free cancellation. Book now with BYHOURS, leader in Microstays.",
      "keywords": "hotels, destinations, byhours"
    },
    "privacy": {
      "title": "Privacy policy",
      "description": "BYHOURS privacy and data protection policy. How we handle your personal data when you use our hotel-by-the-hour booking services."
    },
    "terms": {
      "title": "Terms and conditions",
      "description": "BYHOURS terms and conditions of use. Conditions for booking hotel rooms by the hour in more than 4,000 hotels."
    },
    "onDemand": {
      "title": "BYHOURS On Demand — Availability request",
      "description": "Tell us what you need and our team will help you find on-demand availability."
    },
    "hoteliers": {
      "title": "BYHOURS for hoteliers — Turn empty hours into revenue",
      "description": "Sell microstays in 3, 6 and 24-hour slots on your terms: pricing, availability and your own channel. No minimum allotment.",
      "ogTitle": "BYHOURS for hoteliers",
      "ogDescription": "Monetise idle inventory with microstays and full control from the extranet."
    }
  },
  "stickyBookingBar": {
    "reservarAhora": "Book now",
    "elegirHora": "Choose time",
    "aria": "Quick booking bar"
  },
  "roomCard": {
    "badges": {
      "freeCancellation": "Free cancellation up to 24h",
      "payNow": "Pay now",
      "payAtDestination": "Pay at property"
    },
    "packWindow": {
      "allDay": "All day"
    },
    "packOption": {
      "hours": "{count} hours",
      "vatIncluded": "VAT included",
      "availabilityTitle": "Availability",
      "extraHourPromo": "Includes 1 extra hour of stay"
    },
    "realPrice": {
      "taxesIncluded": "Taxes and fees included",
      "taxesNotIncluded": "Taxes and fees not included",
      "taxesBreakdown": "Taxes and fees breakdown"
    },
    "reserve": "Book"
  },
  "searchCard": {
    "urgency": {
      "oneRoom": "1 room left",
      "moreRooms": "{count} rooms left"
    },
    "viewRooms": "View rooms",
    "availablePacks": {
      "one": "{pack}h stay",
      "many": "Stays {packs}"
    },
    "promos": {
      "multiple": "{count} promotions",
      "modalTitle": "Available promotions"
    }
  },
  "buttons": {
    "borrar": "Delete",
    "reiniciar": "Reset",
    "aplicar": "Apply",
    "cerrar": "Close",
    "filtros": "Filters",
    "buscar": "Search",
    "cargando": "Loading",
    "mapa": "Global map",
    "buscarZona": "Search in this area",
    "filtroEntrada": "Check-in time",
    "eligeHorario": "Choose your schedule",
    "continuar": "Continue",
    "continuarSinExtras": "Continue without extras",
    "cancel": "Cancel",
    "buscarDia": "Search another day",
    "buscarOtroHotel": "Search another hotel",
    "noDispo": "Not available",
    "dispo": "Check-in time",
    "dispoOtrosDias": "Available other days",
    "moreImg": "More images",
    "readMore": "Read more",
    "readLess": "Read less",
    "reservar": "Book",
    "cancelBook": "Cancel booking",
    "modifyBook": "Modify booking",
    "repeatBook": "Repeat booking",
    "deleteBook": "Delete booking",
    "clearHistory": "Clear history",
    "desde": "From",
    "todos": "All",
    "login": "Log in",
    "verMapa": "View map",
    "compartir": "Share",
    "guardar": "Save",
    "guardado": "Saved"
  },
  "labels": {
    "hoy": "Today",
    "mañana": "Tomorrow",
    "dia": "day",
    "dateRangeShortMinus1": "- 1 day",
    "dateRangeShortPlus1": "+ 1 day",
    "dateRangeShortBoth": "± 1 day",
    "dateRangeMinus1": "Search one day before",
    "dateRangePlus1": "Search one day after",
    "dateRangeBoth": "Search one day before and after",
    "dateRangeSelector": "Expand search to nearby days",
    "horas": "hours",
    "hoteles": "hotels",
    "todoDia": "All day",
    "searchDestino": "Destinations matching",
    "destinosPopulares": "Popular destinations",
    "busquedasRecientes": "Recent searches",
    "placeholderDestino": "Search for destination...",
    "ubicacion": "Location",
    "rooms": "Rooms",
    "pack": "Hour pack",
    "entrada": "Check-in",
    "horarioReserva": "Booking schedule",
    "salida": "Check-out",
    "nombre": "First name",
    "apellido": "Last name",
    "ciudad": "City",
    "telefono": "Phone",
    "extras": "Booked extras",
    "password": "Current password",
    "newPassword": "New password",
    "repeatPassword": "Repeat new password",
    "passwordRequirements": {
      "length": "At least 8 characters",
      "uppercase": "At least 1 uppercase letter",
      "lowercase": "At least 1 lowercase letter",
      "number": "At least 1 number"
    },
    "email": "Email",
    "detalle": "Details",
    "pago": "Payment details",
    "pagado": "Paid",
    "total": "Total",
    "changePassword": "Change password",
    "precioHab": "per room",
    "errorHora": "Choose your check-in time",
    "errorHotel": "We couldn't find the hotel",
    "errorDestino": "Destination not found",
    "errorPaginaNoEncontrada": "Page not found",
    "errorPaginaNoEncontradaSubtitle": "The page you are looking for does not exist.",
    "verHoteles": "View hotels in {city_name}",
    "verHotelesDisponibles": "View the {count} hotels available in {city_name}",
    "destacados": "Featured hotels in {city_name}",
    "reserva": "Find your hotel by the hour",
    "descubre": "Discover hotels in {city_name}",
    "comoFunciona": "How does it work?",
    "errorResultado": "Oops... We couldn't find anything that matches your search.",
    "errorResultadoTitle": "No results",
    "destinos": "Destinations",
    "selectDestino": "Select a country",
    "ubicacionActual": "Current location",
    "zonaActual": "Selected area",
    "selectCity": "Select a city",
    "sinDisponibilidadTitle": "No availability at the moment",
    "sinDisponibilidadDescription": "There are currently no hotels available in this destination. We invite you to come back later or explore other options.",
    "buscarOtroDestino": "Search for another destination",
    "buscarOtraUbicacion": "Search another location",
    "numRooms": "No. rooms",
    "hero": {
      "entradaFlexible": "Flexible check-in",
      "hotelesVerificados": "Verified hotels",
      "sinNocheMinima": "No minimum stay"
    },
    "ariaLabelHorarioFlexible": "Flexible schedule information",
    "aria": {
      "home": "Home",
      "idiomaMoneda": "Language and currency",
      "usuario": "User",
      "menu": "Menu",
      "favorito": "Favourite",
      "compartir": "Share",
      "info": "Information",
      "diaAnterior": "Previous day",
      "diaSiguiente": "Next day",
      "descargarAppIos": "Download app for iOS",
      "descargarAppAndroid": "Download app for Android",
      "showPassword": "Show password",
      "hidePassword": "Hide password"
    },
    "login": {
      "title": "Welcome to BYHOURS",
      "password": "Forgot your password?",
      "session": "Log in",
      "noAccount": "Don't have an account?",
      "registerLabel": "Sign up",
      "placeholder": {
        "email": "Email address *",
        "password": "Password *"
      },
      "continue": "Continue",
      "o": "OR",
      "recover": {
        "title": "Recover your password",
        "subtitle": "Enter your email address and we'll send you instructions to reset your password.",
        "subtitle2": "Enter your new password and confirm the new password.",
        "back": "Back to login"
      },
      "register": {
        "title": "Create your BYHOURS account",
        "account": "Already have an account?"
      },
      "google": "Continue with Google",
      "facebook": "Continue with Facebook",
      "footer": {
        "user": "User Agreement",
        "privacy": "Privacy Policy",
        "cookies": "Cookie Policy"
      },
      "emailConfirmation": {
        "title": "Confirm your email address!",
        "subtitle": "We've sent an email to {email} with a link to confirm your email address. If you don't see it in your inbox, check your spam folder.",
        "resend": "Resend email"
      },
      "dropdown": {
        "perfil": "Profile",
        "cerrar": "Log out"
      }
    },
    "proximaReserva": {
      "titulo": "Upcoming booking",
      "ver": "View booking",
      "repetir": "Repeat booking",
      "repetirSubtitulo": "{days} days ago",
      "repetirSubtituloHoy": "You booked today",
      "repetirSubtituloAyer": "You booked yesterday",
      "repetirDescripcion": "You booked {days} days ago at {hotel}",
      "repetirDescripcionHoy": "You booked today at {hotel}",
      "repetirDescripcionAyer": "You booked yesterday at {hotel}"
    },
    "user_zone": {
      "emailVerified": {
        "title": "Email verified",
        "description": "You can now use the user area as usual."
      },
      "menu": {
        "perfil": "Profile",
        "reservas": "My bookings",
        "favoritos": "Favorites",
        "inicio": "BYHOURS Home",
        "cerrarSesion": "Log out"
      },
      "favoritos": {
        "noFavoritosTitle": "You don't have any favorites yet",
        "noFavoritosSubtitle": "What are you waiting for? Mark your favorite hotels",
        "completeProfile": "You must complete your profile to add hotels to favorites"
      },
      "perfil": {
        "danger": "Danger zone",
        "deleteAccount": "Delete account",
        "deleteAccountText": "Are you sure you want to delete your account?",
        "deleteAccountText2": "This action is permanent and cannot be undone. All your data will be permanently deleted.",
        "successUpdate": "Information has been updated successfully",
        "successDelete": "User has been deleted successfully"
      },
      "reservas": {
        "noReservasTitle": "You don't have any bookings yet",
        "noReservasSubtitle": "What are you waiting for? Book your room with us",
        "activas": "Active",
        "pasadas": "Past",
        "cancelled": "Cancelled",
        "cancel": "Booking cancelled successfully",
        "cancelError": "Error cancelling booking",
        "reference": "Reference",
        "price": "Price",
        "cancelText": "Are you sure you want to cancel the booking?",
        "cancelText2": "If you cancel now, you might lose your current booking.",
        "deleteText": "Are you sure you want to delete this booking?",
        "deleteText2": "This action is permanent and you won't be able to recover the booking.",
        "deleteSuccess": "Booking deleted successfully",
        "deleteError": "Error deleting booking",
        "clearHistoryText": "Are you sure you want to clear all history?",
        "clearHistoryText2": "All your past bookings will be permanently hidden.",
        "clearHistorySuccess": "History cleared successfully",
        "clearHistoryError": "Error clearing history",
        "detalle": {
          "titulo": "Booking details",
          "tiempo": "Stay duration"
        }
      }
    },
    "cancelBook": {
      "title": "Cancel booking",
      "subtitle": "Enter your booking reference and the email you used to book. You can only cancel if you meet the cancellation policy (for example, at least 24 hours before check-in).",
      "referenceError": "Enter your booking reference",
      "referencePlaceholder": "Booking reference",
      "emailPlaceholder": "Email",
      "submit": "Cancel booking",
      "success": "Your booking has been cancelled successfully",
      "genericError": "We could not cancel the booking",
      "backHome": "Back to home"
    },
    "tags": {
      "piscina": "Enjoy pool access included with your booking! 💦"
    },
    "tooltips": {
      "packHours": "You can book {hours}h within this time slot",
      "horarioFlexible": "Your check-in is flexible within the shown schedule, but check-out must be on time."
    },
    "extraHours": {
      "maxExtraHours": "A maximum of {hours} extra hours can be added",
      "noExtraHours": "Extra hours cannot be added to the selected time"
    },
    "horasDisponibles": "Available hours",
    "gratis": "Free"
  },
  "errors": {
    "search": "An error occurred while searching for hotels. Please try again.",
    "ubicacion": {
      "support": "It seems your browser doesn't support geolocation. Try another browser or enable the option in settings.",
      "block": "Location is blocked in your browser. To enable it, go to settings and allow location access.",
      "permission": "We couldn't access your location because you denied permission. You can enable it in your device settings.",
      "gps": "We couldn't determine your location. Make sure GPS is enabled and you have a stable connection.",
      "timeout": "The location request is taking longer than expected. Please try again in a moment.",
      "error": "An error occurred while trying to get your location. Please try again."
    },
    "login": {
      "email": "Invalid email",
      "password": "At least 8 characters",
      "passwordComplexity": "Must contain at least one uppercase letter, one lowercase letter and one number",
      "repeatPassword": "Passwords do not match",
      "emailDomain": "The email domain doesn't seem valid",
      "facebook_email_required": "Facebook didn't share your email with us. To log in with Facebook on BYHOURS, go to your Facebook app settings and grant email permission to BYHOURS."
    },
    "user_zone": {
      "delete": "Error deleting user",
      "password": "Error changing password"
    },
    "required": "This field is required",
    "invalid": "Invalid value",
    "minLength": "Minimum {min} characters",
    "maxLength": "Maximum {max} characters",
    "min": "Minimum value {min}",
    "max": "Maximum value {max}",
    "email": "Invalid email",
    "url": "Invalid URL",
    "number": "Must be a number",
    "integer": "Must be an integer",
    "decimal": "Must be a decimal",
    "date": "Invalid date",
    "time": "Invalid time",
    "datetime": "Invalid date and time",
    "phone": "Invalid phone",
    "password": "Invalid password",
    "passwordMatch": "Passwords do not match",
    "generic": "An error occurred",
    "network": "Network error",
    "server": "Server error",
    "notFound": "Not found",
    "unauthorized": "Unauthorized",
    "forbidden": "Forbidden",
    "timeout": "Request timeout",
    "unknown": "Unknown error"
  },
  "share": {
    "copy": "Copy link",
    "whatsapp": "Share on WhatsApp",
    "email": "Share by email",
    "message": "Hello! I'm sharing this hotel that I found interesting: {url}"
  },
  "checkout": {
    "meta": {
      "title": "Checkout",
      "description": "Complete your booking"
    },
    "timer": "Your room is reserved for {time} minutes",
    "steps": {
      "checkinHour": "Check-in time",
      "data": "Your details",
      "payment": "Secure payment",
      "back": "Back"
    },
    "sections": {
      "completeCheckinHour": "Select your check-in time to continue"
    },
    "checkinHour": {
      "title": "Check-in time",
      "subtitle": "Choose when you want to check in",
      "required": "Select a check-in time to continue",
      "pendingSummary": "Select your check-in time",
      "description": "Choose your check-in time within {window}; from that time you'll enjoy {hours} hours of stay.",
      "descriptionNoWindow": "Choose your check-in time; from that time you'll enjoy {hours} hours of stay.",
      "placeholder": "Choose your check-in time",
      "changeHour": "Change check-in time",
      "descriptionSelected": "Flexible check-in from {checkin}. Your room is available from {checkin} to {checkout}."
    },
    "extras": {
      "title": "Extras",
      "continueWithout": "Continue without extras",
      "noneForHour": "No extras available for the selected check-in time"
    },
    "recovery": {
      "title": "You have a booking in progress",
      "finishBooking": "Finish my booking",
      "closeAria": "Dismiss booking reminder"
    },
    "contactData": {
      "title": "Contact details",
      "loginPrompt": "Already have an account?",
      "loginButton": "Log in",
      "registerButton": "Sign up",
      "loginPromptSuffix": "to speed up your future bookings.",
      "continueAsGuest": "Continue as guest",
      "firstName": "First name",
      "firstNamePlaceholder": "John",
      "lastName": "Last name",
      "lastNamePlaceholder": "Smith",
      "email": "Email",
      "emailPlaceholder": "john.smith{'@'}byhours.com",
      "phone": "Phone",
      "phonePlaceholder": "612 345 678",
      "city": "City",
      "cityPlaceholder": "London"
    },
    "promoCode": {
      "title": "Promotional code",
      "placeholder": "Example: SUMMER10",
      "apply": "Apply",
      "applied": "Promotional code applied",
      "remove": "Remove",
      "errors": {
        "required": "Enter a valid promotional code",
        "invalid": "Invalid promotional code",
        "generic": "Error applying promotional code"
      }
    },
    "comments": {
      "title": "Comments for the hotel",
      "placeholder": "Example: 'I need a wheelchair accessible room'"
    },
    "payment": {
      "title": "Payment method"
    },
    "trustBadges": {
      "securePayment": "Secure payment (Stripe)",
      "freeCancellation": "Free cancellation",
      "encryptedData": "Encrypted data"
    },
    "terms": {
      "text": "By booking you are accepting our",
      "userAgreement": "User Agreement",
      "privacyText": "At BYHOURS we will process your personal data to manage your booking and keep you informed throughout the process.",
      "privacyInfo": "For more information see our",
      "privacyPolicy": "Privacy Policy"
    },
    "buttons": {
      "continue": "Continue",
      "confirmAndPay": "Confirm and pay now",
      "payNow": "Pay now"
    },
    "loading": "Processing payment...",
    "summary": {
      "hotel": "Hotel",
      "address": "Address",
      "checkIn": "Check-in",
      "checkOut": "Check-out",
      "hotelTaxes": "Hotel taxes and fees",
      "hotelTaxesTooltip": "Depending on the destination, some taxes and/or fees (such as tourist tax) may not be included in the price and must be paid directly at the hotel",
      "bookingFees": "Booking fees",
      "bookingFeesTooltip": "Fee for management expenses",
      "promoDiscount": "Promotional discount",
      "payAtHotel": "To pay at hotel",
      "payAtHotelTooltip": "You'll pay in the property's currency (exchange rate may vary)",
      "payNow": "Now you only pay",
      "total": "TOTAL",
      "freeCancellation": "Free cancellation up to 24h before check-in; afterwards, the hotel may charge the full amount.",
      "paymentSplit": "Now you only pay {nowAmount}, the rest ({hotelAmount}) to pay at the hotel.",
      "seeDetails": "View details",
      "taxesInfo": "Some taxes and/or fees (such as tourist tax) may not be included in the final price and must be paid directly at the hotel"
    },
    "paymentDetails": {
      "title": "Payment and cancellation details",
      "paymentCharges": {
        "title": "Payment and charges",
        "item1": "The charge you'll see on your account will be: \"Travel Payment\".",
        "item2": "You're only paying a portion now (management fees) and the rest of the amount is paid directly at the hotel.",
        "item3": "You're paying the total accommodation amount in advance."
      },
      "cancellations": {
        "title": "Cancellations and no-shows",
        "item1": "If you book with less than 24h notice, it won't be possible to cancel.",
        "item2": "If you cancel within the deadline, we'll refund the amount paid.",
        "item3": "The hotel reserves the right to charge 100% of the amount if you don't show up or cancel outside the deadline."
      },
      "checkIn": {
        "title": "Check-in",
        "idRequired": "Presenting a valid ID document (national ID or passport) is mandatory for all guests staying at the hotel."
      },
      "support": {
        "title": "Customer service",
        "scheduleMondayThursday": "Monday to Thursday from 9am to 12:00am (UTC/GMT +1)",
        "scheduleFriday": "Friday from 9am to 9:00pm (UTC/GMT +1)",
        "scheduleWeekend": "Saturdays, Sundays and holidays from 9:30am to 6:30pm (UTC/GMT +1)",
        "whatsapp": "You can contact us via",
        "email": "You can write to us at:",
        "phones": "Contact phones",
        "uk": "United Kingdom:",
        "france": "France:",
        "mexico": "Mexico:",
        "colombia": "Colombia:",
        "spain": "Spain:"
      }
    },
    "errors": {
      "title": "Error",
      "firstNameRequired": "First name is required",
      "lastNameRequired": "Last name is required",
      "emailRequired": "Email is required",
      "emailInvalid": "Email is not valid",
      "phoneInvalid": "Phone can only contain numbers",
      "stripeNotAvailable": "Stripe is not available",
      "initializePaymentError": "Error initializing payment",
      "initializePaymentRetry": "Could not initialize payment. Please try again.",
      "clientSecretError": "Could not get client secret",
      "paymentContainerError": "Payment container is not available after multiple attempts",
      "bookingInitError": "Could not initialize booking",
      "paymentElementsError": "Payment elements not initialized",
      "confirmPaymentError": "Error confirming payment",
      "paymentIntentError": "Could not get payment intent",
      "paymentIncompleteError": "Payment was not completed successfully. Status: {status}",
      "authenticationFailure": "Bank verification could not be completed. Please enter your card again. If it keeps failing, try a new incognito tab or the app.",
      "bookingConfirmError": "Error confirming booking",
      "unexpectedPaymentError": "Unexpected error in payment process",
      "preBooking": {
        "noAvailability": {
          "title": "This option is no longer available",
          "description": "Please choose another room at the hotel."
        },
        "hourUnavailable": {
          "title": "That time is no longer available",
          "description": "Please try a different check-in time."
        },
        "retryable": {
          "title": "We could not continue",
          "description": "Please try again in a moment."
        },
        "network": {
          "title": "Connection problem",
          "description": "Check your connection and try again."
        },
        "missingData": {
          "title": "Missing information",
          "description": "Please review your contact details and try again."
        },
        "blacklist": {
          "title": "We cannot complete this booking",
          "description": "Please contact us to continue."
        },
        "duplicatedBook": {
          "title": "We could not continue",
          "description": "Check your bookings or try again in a few minutes."
        },
        "invalidPromo": {
          "title": "Invalid promotional code",
          "description": "Remove it and try again."
        },
        "paymentFailed": {
          "title": "Could not start payment",
          "description": "Please try again in a moment."
        },
        "actions": {
          "changeHour": "Choose another time",
          "viewHotel": "View hotel",
          "retry": "Retry",
          "reviewData": "Review my details",
          "removePromo": "Remove code and retry",
          "myBookings": "View my bookings"
        }
      }
    }
  },
  "confirm": {
    "meta": {
      "title": "Successful payment",
      "description": "Your booking has been confirmed"
    },
    "header": {
      "title": "Payment successful!",
      "subtitle": "Your booking has been confirmed",
      "reference": "Reference:"
    },
    "loading": "Verifying payment...",
    "personalData": {
      "title": "Personal data",
      "name": "First name",
      "lastName": "Last name",
      "email": "Email",
      "phone": "Phone"
    },
    "location": {
      "title": "Location"
    },
    "help": {
      "title": "Need help?"
    },
    "buttons": {
      "viewBookings": "View my bookings",
      "searchMore": "Search for more hotels"
    }
  },
  "onDemandPage": {
    "title": "Can't find availability? We'll handle it for you",
    "subtitle": "Tell us what you're looking for and our team will review hourly-stay options for your destination and dates.",
    "sections": {
      "contact": "Contact details",
      "trip": "Destination & dates",
      "additional": "Additional information"
    },
    "fields": {
      "name": "Name",
      "email": "Email",
      "destination": "Destination",
      "destinationPlaceholder": "Search city",
      "checkinDate": "Check-in date",
      "checkinTime": "Check-in time",
      "pack": "Hour pack",
      "summary": "Summary",
      "attemptedBooking": "What did you try to book?",
      "attemptedPlaceholder": "Hotel name, link or details of the stay you were looking for"
    },
    "privacy": {
      "checkboxBefore": "I accept the ",
      "link": "privacy policy",
      "checkboxAfter": " and the processing of my data to handle this request."
    },
    "submit": "Send request",
    "backHome": "Back to home",
    "success": {
      "title": "Request received",
      "body": "We have registered your request. We will contact you as soon as possible.",
      "backSearch": "Back to hotel search"
    },
    "errors": {
      "required": "This field is required",
      "email": "Invalid email",
      "privacy": "You must accept the privacy policy",
      "attemptedMax": "Text is too long",
      "generic": "Could not send the request. Please try again.",
      "timeOnTheHour": "Choose a time on the hour",
      "validationToastTitle": "Cannot submit",
      "checkinPast": "Check-in date and time must be after the current moment.",
      "roomsRange": "Choose between 1 and 10 rooms"
    }
  },
  "strapi": {
    "hotelPage": {
      "descripcion": "Description",
      "ubicacion": "Location",
      "servicios": "Services",
      "reserva": "Book a room",
      "verHabitaciones": "View rooms",
      "preguntas": "Frequently Asked Questions",
      "info": "Important Information",
      "distance_airport": "Distance to airport",
      "shuttle_service": "Shuttle service",
      "shuttle_service_information": "Shuttle service information",
      "taxi_distance": "Taxi distance",
      "public_transport": "Public transport",
      "noRooms": "No rooms available for the selected dates",
      "noRoomsEmpty": {
        "titulo": "No rooms for this date",
        "descripcion": "Rooms are fully booked for the selected day. Choose another available date."
      },
      "extraDescription": "Select the extras you want to add to your booking",
      "extra": {
        "titulo": "Extras",
        "subtitulo": "Add extras to your booking"
      },
      "max_pers": {
        "titulo": "Max",
        "subtitulo": "people"
      },
      "noDispo": {
        "titulo": "No availability at this hotel",
        "subtitulo": "There are no rooms available for the selected dates",
        "descripcionAmigable": "There is no availability at this hotel at the moment."
      },
      "hotelesCercanos": "Discover more hotels nearby"
    },
    "searchPage": {
      "filtroHora": "Check-in time",
      "resultados": "results in",
      "filtroPack": "Pack",
      "filtroPromo": "Promotion",
      "filtroPrecio": "Price",
      "filtroEstrella": "Category",
      "filtroServicio": "Services",
      "resultadosAlternativos": "Alternative results in",
      "resultadosNear": "Nearby results",
      "horasEntrada": "Check-in times",
      "sinHorasEntrada": "No check-in times available",
      "searchZona": "Search in this area",
      "sinResultados": {
        "titulo": "Oh no :( No hotels available for your search, try with another day, time or destination.",
        "subtitulo": null
      },
      "sinResultadoFiltro": {
        "titulo": "No hotels with the selected filters",
        "subtitulo": null
      },
      "sinHoteles": {
        "titulo": "Oops! Out of the 600 cities where you can book hotels by the hour, you found one where we're not yet available.",
        "subtitulo": null
      },
      "onDemand": {
        "titulo": "Can't find what you're looking for?",
        "subtitulo": "We'll find it within 24 hours!"
      },
      "buscandoFechasCercanas": "Searching for availability on other dates…",
      "disponiblesFechasCercanas": "Available on nearby dates in",
      "disponibleEl": "Available on",
      "probarOtraFecha": "Try another date:",
      "chipManana": "Tomorrow",
      "chipPasadoManana": "Day after tomorrow",
      "ordenacion": [
        "Relevance",
        "Price (low to high)",
        "Price (high to low)",
        "Category (lowest to highest)",
        "Category (highest to lowest)"
      ]
    },
    "homePage": {
      "labelHoteles": "See more hotels in"
    },
    "global": {
      "header": {
        "tituloIdioma": "Language",
        "tituloMoneda": "Currency",
        "tituloDestinos": "Destinations",
        "labelDestinos": "Destinations",
        "labelPartners": "Partners",
        "labelAyuda": "Help",
        "destinos": {
          "madrid": "Madrid",
          "barcelona": "Barcelona",
          "berlin": "Berlin",
          "paris": "Paris",
          "roma": "Rome",
          "dubai": "Dubai",
          "bogota": "Bogotá",
          "mexico": "Mexico City",
          "lima": "Lima",
          "panama": "Panama City"
        },
        "buttonDestinos": {
          "label": "See all destinations",
          "link": "destinations",
          "url": false
        },
        "buttonFunciona": {
          "label": "How does it work?",
          "link": "how-it-works",
          "url": false
        },
        "buttonPartner": {
          "hoteleros": "Hoteliers",
          "agencias": "Travel agencies"
        },
        "buttonAyuda": {
          "contacto": "Contact",
          "preguntas": "Frequently asked questions"
        }
      },
      "footer": {
        "tituloPrivacidad": "Privacy",
        "tituloInformacion": "Information",
        "tituloHoteleros": "Hoteliers",
        "subtituloHoteleros": "Join BYHOURS!",
        "tituloAgencia": "Are you a travel agency?",
        "subtituloAgencia": "Join BYHOURS!",
        "tituloDestinos": "Some destinations",
        "tituloSiguenos": "Follow us",
        "tituloApp": "Download the app",
        "buttonsApp": {
          "appStore": "App Store",
          "googlePlay": "Google Play"
        },
        "redes": {
          "instagram": "Instagram",
          "facebook": "Facebook",
          "x": "X",
          "linkedin": "Linkedin",
          "tiktok": "Tik Tok",
          "youtube": "Youtube"
        },
        "destinos": {
          "madrid": "Madrid",
          "barcelona": "Barcelona",
          "berlin": "Berlin",
          "paris": "Paris",
          "roma": "Rome",
          "dubai": "Dubai",
          "bogota": "Bogotá",
          "mexico": "Mexico City",
          "lima": "Lima",
          "panama": "Panama City",
          "zurich": "Zurich",
          "viena": "Vienna",
          "londres": "London",
          "milan": "Milan",
          "doha": "Doha",
          "buenosAires": "Buenos Aires",
          "quito": "Quito",
          "santiago": "Santiago de Chile"
        },
        "buttonAgencia": {
          "label": "Access portal"
        },
        "buttonHotelero": {
          "label": "Access portal"
        },
        "infoLinks": {
          "ayuda": "Help",
          "contacto": "Contact",
          "blog": "Blog",
          "unete": "Join the team"
        },
        "privacidadLinks": {
          "acuerdo": "User agreement",
          "privacidad": "Privacy policy",
          "cookies": "Cookie policy"
        },
        "keywords": {
          "hotelesPorHoras": "Hotels by the hour",
          "hotelDeDia": "Day use hotels",
          "habitacionPorHoras": "Rooms by the hour"
        }
      }
    }
  },
  "hoteliersPage": {
    "breadcrumb": {
      "home": "Home",
      "current": "For hoteliers"
    },
    "hero": {
      "title": "Turn your rooms’ empty hours into revenue",
      "description": "Vende microestancias en franjas de 3, 6 y 24 horas con las reglas que tú gestiones; franja horaria, disponibilidad y canal propio, sin compromiso de cupo.",
      "cta": "Join our hotel network",
      "imageAlt": "BYHOURS for hoteliers"
    },
    "whyTitle": "Why BYHOURS",
    "features": [
      {
        "title": "Full flexibility",
        "description": "Run the platform your way: how and when to offer microstays."
      },
      {
        "title": "No minimum allotment",
        "description": "We don’t require a minimum number of rooms. Open and close availability whenever you decide."
      },
      {
        "title": "Differentiated product",
        "description": "Distinct from overnight selling: fewer rate parity issues across your usual channels."
      },
      {
        "title": "Room revenue",
        "description": "Monetise slots and days when the room doesn’t sell overnight."
      },
      {
        "title": "New guest segments",
        "description": "Reach corporate travellers, layovers and leisure guests who book by the hour."
      },
      {
        "title": "No lock-in",
        "description": "Try the model with no long-term commitment."
      }
    ],
    "whoWeAre": {
      "title": "Who we are",
      "description": "Leaders in microstays since 2012. Cumulative figures and today’s network: international chains and independents increase RevPAR with BYHOURS in hundreds of destinations.",
      "ctaQuestion": "Ready to see how it fits your hotel?",
      "ctaButton": "Request information"
    },
    "stats": [
      {
        "title": "+15 M€",
        "description": "Generated for our hotels (cumulative)"
      },
      {
        "title": "+300 K",
        "description": "Microstay bookings generated"
      },
      {
        "title": "+250 K",
        "description": "Happy customers"
      },
      {
        "title": "24",
        "description": "Markets in Europe, Latin America and Middle East"
      },
      {
        "title": "+600",
        "description": "Destinations available"
      },
      {
        "title": "+4000",
        "description": "Partner hotels already earning extra revenue"
      }
    ],
    "video": {
      "title": "BYHOURS for your hotel",
      "description": "See how BYHOURS can help you monetise empty rooms and grow revenue.",
      "iframeTitle": "BYHOURS for hoteliers — video"
    },
    "widget": {
      "title": "Sell by the hour from your own website",
      "description": "With one line of code your site adds a floating button that opens the hourly search: guests book microstays instantly without leaving your hotel’s environment.",
      "pillars": [
        {
          "title": "Integration in minutes",
          "description": "Lightweight go-live: no long projects or website changes beyond the snippet agreed with your team or vendor."
        },
        {
          "title": "Hourly booking in one click",
          "description": "Visitors see a floating button that opens the microstay finder: they pick a slot and complete the booking on your site."
        },
        {
          "title": "You stay in control",
          "description": "Price, availability and rules still come from your BYHOURS extranet: the widget only shows what you allow."
        }
      ],
      "featuresSubtitle": "Widget features",
      "widgetFeatures": [
        {
          "title": "Brand colours and copy",
          "description": "Adjust primary and secondary colours, button radius and CTA copy; finder content can follow your language settings."
        },
        {
          "title": "Floating or embedded",
          "description": "Corner button or embedded block: choose what fits your layout and navigation."
        },
        {
          "title": "Different rules on mobile and desktop",
          "description": "Set button position, offsets and behaviour separately for large and small screens so nothing covers key content."
        }
      ],
      "cta": "Request integration",
      "figcaption": "The floating button opens the microstay finder without leaving the hotel website.",
      "imageAlt": "Example of the hourly booking widget embedded on a hotel website"
    },
    "examples": {
      "title": "Three real client examples",
      "description": "Properties already earning microstays with BYHOURS. Figures are illustrative estimates by market and commercial policy.",
      "benefitLabel": "Benefit for the hotel",
      "bookingsLabel": "Bookings with BYHOURS",
      "cta": "I want to join the network",
      "cases": [
        {
          "badge": "Barcelona",
          "title": "4-star hotel",
          "description": "Mixed market of conferences, cruises and city tourism: microstays fill gaps between overnight stays and last-minute demand in a competitive area.",
          "revenue": "+700k €",
          "bookings": "+14k"
        },
        {
          "badge": "Madrid",
          "title": "Urban hotel",
          "description": "Uncategorised star hotel using the hourly channel for pass-through guests, remote work and short stays without competing on overnight BAR alone.",
          "revenue": "+300k €",
          "bookings": "+7k"
        },
        {
          "badge": "Bogotá",
          "title": "5-star hotel",
          "description": "Premium profile in an Andean capital: business, events and corporate guests who value hour packs aligned with tight schedules.",
          "revenue": "+400k €",
          "bookings": "+12k"
        }
      ]
    },
    "testimonialsTitle": "What our partners say",
    "testimonials": [
      {
        "quote": "Pricing and last-minute availability flexibility helps us improve ADR in slots that used to stay empty.",
        "name": "Juan Reyna",
        "role": "Director of Sales & Marketing — Hilton Barcelona",
        "kind": "hilton"
      },
      {
        "quote": "In a market where guests are increasingly eclectic, having a solution like BYHOURS allows us to attract a type of guest who does not always find an offer that suits their needs. In addition, having an easy-to-use platform that offers all the control and flexibility needed means generating additional revenue has never been simpler.",
        "name": "Xavier Micó",
        "role": "General Manager — Four Points by Sheraton",
        "kind": "marriott"
      },
      {
        "quote": "The BYHOURS platform offers an innovative and flexible solution for hotels to maximize their room occupancy. A particularly noteworthy feature is the ability to offer rooms not only for full days (24h), but also for periods of 3 or 6 hours. This opens up entirely new opportunities for hotels to reduce vacancies and generate additional revenue.\n\nThe extranet is also impressive across the board: it is clear, intuitively designed, and enables simple and efficient management of listings. Even without a long training period, you can quickly find your way around and use all the important features without any issues.\n\nAnother major plus is the customer service. Inquiries are processed quickly and always answered in a friendly and professional manner. You always feel well taken care of and supported, which makes working with them particularly pleasant. Overall, BYHOURS is a well-designed and modern platform that impresses with both its functionality and its excellent service.",
        "name": "Robert Franke",
        "role": "Channelmanagement Coordinator — GHC Hotels",
        "kind": "ghc"
      },
      {
        "quote": "BYHOURS has become an essential tool for our day-to-day operations. It offers maximum flexibility in managing availability, rates, custom packages and full control of commercial strategy, enabling immediate adaptation to market fluctuations, cancellations, early departures, etc.\n\nThe impact on revenue has been very positive: we have achieved a significant increase in income. Its intuitive interface, total flexibility and exceptional customer support greatly streamline processes, reducing management time and minimising operational errors.\n\nIt is currently an indispensable complement for our hotel.",
        "name": "Anonymous",
        "role": "Hotel partner",
        "kind": "anonymous"
      }
    ],
    "demand": {
      "title": "Your hotel reaches these demand profiles",
      "description": "This is how hourly bookers behave: covering these segments grows occupancy and revenue beyond the overnight-only pattern.",
      "items": [
        {
          "title": "Business and work",
          "paragraph": "Professionals who need Wi‑Fi, a break between meetings or privacy away from the office. They book daytime slots that fit your inventory between overnight stays."
        },
        {
          "title": "Travellers",
          "paragraph": "Passengers with connections, delays or long waits: they want a shower, rest and comfort near the airport or station. Your hotel meets a need that an overnight stay doesn’t always solve."
        },
        {
          "title": "Lifestyle and leisure",
          "paragraph": "Spa, pool or terrace before or after concerts, shopping or urban weekends. You capture leisure demand that prefers to pay only for the hours used."
        }
      ]
    },
    "steps": {
      "title": "How to become part of BYHOURS?",
      "description": "Earning with BYHOURS is simple. In three steps you can start monetising empty rooms.",
      "items": [
        {
          "title": "Sign up",
          "description": "Fill in the form and we’ll get in touch.",
          "linkToForm": true
        },
        {
          "title": "Training",
          "description": "In a short onboarding you’ll load your first availability and learn to use the platform.",
          "linkToForm": false
        },
        {
          "title": "Sales",
          "description": "Your hotel is live: you can sell and monetise empty rooms with BYHOURS.",
          "linkToForm": false
        }
      ]
    },
    "form": {
      "title": "Join our hotel network",
      "description": "Send your request and we’ll contact you as soon as possible to learn about your hotel and next steps. Information is only used to respond to your enquiry; data controller: BYHOURS Travel S.L.",
      "successTitle": "Request sent",
      "successDescription": "Thank you. We’ve received your message and will contact you shortly.",
      "hotelSection": "Hotel details",
      "contactSection": "Contact",
      "hotelName": "Hotel name",
      "website": "Website (optional)",
      "rooms": "Number of rooms",
      "roomsPlaceholder": "Select a range…",
      "cityCountry": "Hotel location",
      "cityPlaceholder": "Search city…",
      "contactName": "Contact name",
      "email": "Email",
      "phone": "Phone",
      "comments": "Comments (optional)",
      "commentsPlaceholder": "Tell us what you need: working with us, widget integration, commercial questions…",
      "privacyBefore": "I accept the ",
      "privacyLink": "privacy policy",
      "privacyAfter": " and the processing of my data to respond to this request.",
      "submit": "Send request",
      "websitePlaceholder": "https://hotel.example.com"
    },
    "faq": {
      "title": "Questions?",
      "description": "Answers to what revenue managers and sales teams often ask.",
      "items": [
        {
          "label": "What is a microstay?",
          "content": "A hotel booking for 3, 6 or 24 hours where the guest chooses check-in time within the day. You control price and availability per slot."
        },
        {
          "label": "Is there a minimum allotment or commitment?",
          "content": "We don’t require a minimum number of rooms or a lock-in period. You can try the model and adjust when needed."
        },
        {
          "label": "Does it affect BAR or yield?",
          "content": "The product is a differentiated line for other segments (business, layovers, last minute), filling gaps without replacing overnight sales."
        },
        {
          "label": "How is slot pricing set?",
          "content": "You set rates and microstay rules in the extranet with the flexibility your strategy needs. Our team supports your initial setup."
        },
        {
          "label": "Are there commissions or a revenue share?",
          "content": "Commercial terms (commissions, settlements) are agreed when joining the partner programme. We explain them in the first conversation after your request."
        },
        {
          "label": "Does it integrate with my PMS or channel manager?",
          "content": "We assess integrations based on your stack. Tell us which systems you use in the form or on the welcome call and we’ll find the best option."
        },
        {
          "label": "How does billing work for guest and hotel?",
          "content": "BYHOURS collects from the guest according to your partner contract; we explain billing and settlements during onboarding."
        },
        {
          "label": "What do I need to get started?",
          "content": "Fill in the form on this page. Our team guides you through setup and your first availability publish on the extranet."
        }
      ]
    },
    "toast": {
      "validationTitle": "Check the form"
    },
    "errors": {
      "server": "Could not send. Please try again."
    },
    "validation": {
      "hotelName": "Enter the hotel name",
      "websiteMax": "Website URL is too long",
      "rooms": "Select a room range",
      "cityCountry": "Enter city and country",
      "contactName": "Enter the contact name",
      "emailRequired": "Enter your email",
      "emailInvalid": "Invalid email",
      "phone": "Enter a phone number",
      "commentsMax": "Maximum 4000 characters",
      "privacy": "You must accept the privacy policy"
    },
    "roomRanges": [
      {
        "label": "1 – 9",
        "value": "1-9"
      },
      {
        "label": "10 – 19",
        "value": "10-19"
      },
      {
        "label": "20 – 59",
        "value": "20-59"
      },
      {
        "label": "60 – 99",
        "value": "60-99"
      },
      {
        "label": "100 or more",
        "value": "100+"
      }
    ]
  }
}
